<script setup lang="ts">
import LandingTitleLayout from '../LandingTitleLayout.vue';
import { tariffs, YEAR_DISCOUNT_PERCENT } from '../../content';
import { formatPrice } from '@glow/shared/utils/format';

const validity = ref<'year' | 'month'>('year');
const tariffName = ref(tariffs[0].name);
function calculateTariffPrice(monthPrice: number) {
  const yearPrice = monthPrice * 12;
  return validity.value === 'month'
    ? monthPrice
    : Math.ceil(yearPrice - yearPrice * (YEAR_DISCOUNT_PERCENT / 100));
}
</script>

<template>
  <div id="tariff" class="tariff">
    <LandingTitleLayout>
      <template #title>
        Познакомься с
        <span>функциями сервиса</span>
      </template>
      <template #subtitle>Пользуйся сервисом бесплатно</template>
    </LandingTitleLayout>

    <div class="switcher d-flex">
      <AppButton
        :variant="validity === 'year' ? 'primary' : 'secondary'"
        fluid
        @click="validity = 'year'"
      >
        <div class="sale">- {{ YEAR_DISCOUNT_PERCENT }}%</div>
        На год
      </AppButton>
      <AppButton
        :variant="validity === 'month' ? 'primary' : 'secondary'"
        fluid
        @click="validity = 'month'"
      >
        На месяц
      </AppButton>
    </div>
    <div class="switcher d-flex d-md-none">
      <AppButton
        v-for="(tariff, tariffIndex) in tariffs"
        :key="tariffIndex"
        :variant="tariffName === tariff.name ? 'primary' : 'secondary'"
        fluid
        @click="tariffName = tariff.name"
      >
        {{ tariff.name }}
      </AppButton>
    </div>
    <div class="container">
      <div class="tariff__grid">
        <div v-for="(tariff, tariffIndex) in tariffs" :key="tariffIndex">
          <div class="title">{{ tariff.name }}</div>

          <AppSpoiler
            v-for="(benefit, benefitIndex) in tariff.benefits"
            :key="benefitIndex"
            variant="card"
            size="sm"
            class="mb-2"
          >
            <template #header>{{ benefit.title }}</template>
            {{ benefit.text }}
          </AppSpoiler>
          <AppButton class="mt-4" fluid>
            Выбрать за
            {{ formatPrice(calculateTariffPrice(tariff.monthPrice)) }}
          </AppButton>
        </div>
      </div>
      <div class="d-md-none">
        <div v-for="(tariff, tariffIndex) in tariffs" :key="tariffIndex">
          <template v-if="tariff.name === tariffName">
            <AppSpoiler
              v-for="(benefit, benefitIndex) in tariff.benefits"
              :key="benefitIndex"
              variant="card"
              size="sm"
              class="mb-2"
            >
              <template #header>{{ benefit.title }}</template>
              {{ benefit.text }}
            </AppSpoiler>
            <AppButton class="mt-4" fluid>
              Выбрать за
              {{ formatPrice(calculateTariffPrice(tariff.monthPrice)) }}
            </AppButton>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tariff {
  .switcher {
    margin: 20px auto;
    width: 400px;

    @include media-breakpoint-down(md) {
      width: 100%;
    }

    .sale {
      position: absolute;
      margin: -32px auto 0 auto;
      padding: 5px 25px;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      color: var(--app-color-black);
      background: #f4f5fd;
      border-radius: 6px;
    }
  }

  .title {
    margin: 68px 0 26px 0;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    color: var(--app-color-primary);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;

    @include media-breakpoint-down(md) {
      display: none;
    }
  }
}
</style>
